import React from 'react';
import * as Yup from 'yup';
import { PasswordInputRHF } from '@cd/rhf';
import { FormCardRHF } from '@cd/rhf';
import useChangePassword from './fetch/useChangePassword';

const PasswordSchema = Yup.object().shape({
	old_password: Yup.string()
		.min(8, 'Too Short!')
		.max(128, 'Too Long!')
		.required('Required'),
	new_password: Yup.string()
		.min(8, 'Too Short!')
		.max(128, 'Too Long!')
		.matches(
			/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,16}$/,
			'Password must have 8 chars long, 1 capital letter, 1 digit and 1 special character'
		)
		.required('Required')
});

const ChangePwd = () => {
	const record = {
		old_password: '',
		new_password: ''
	};
	const { mutate } = useChangePassword();

	return (
		<FormCardRHF
			mode="all"
			schema={PasswordSchema}
			onSubmit={values => mutate(values)}
			title="Change Password"
			subtitle="Change your password here"
			okButtonTitle="CHANGE"
			defaultValues={record}>
			<PasswordInputRHF
				margin="normal"
				label="Old Password"
				name="old_password"
			/>
			<PasswordInputRHF
				margin="normal"
				label="New Password"
				name="new_password"
			/>
		</FormCardRHF>
	);
};

export default ChangePwd;
